import { type GasPayload } from '@atlaskit/analytics-gas-types';

export const onIntentDetectionResponse = ({
	action,
	attributes,
}: {
	action: 'success' | 'fail';
	attributes: Record<string, string>;
}): GasPayload => ({
	source: 'searchDialog',
	eventType: 'track',
	action,
	actionSubject: 'intentDetectionResponse',
	actionSubjectId: 'intentDetection',
	attributes,
});
